import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/modules/confirmation/confirmation.component';

@Injectable({
  providedIn: 'root'
})
export class FormChangeService {
  hasChangesPenging = false;

  constructor(private dialog: MatDialog) {}

  confirm(event: Event): Observable<boolean> | boolean {
    if (this.hasChangesPenging) {
      if (event) return window.confirm();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {});

      return dialogRef.afterClosed().pipe(
        map((value: boolean) => {
          if (value) this.hasChangesPenging = false;
          return value;
        })
      ) as Observable<boolean>;
    }
  }
}
